var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-table-view" },
    [
      _c(
        "el-row",
        { staticClass: "title-wrapper" },
        [
          _c("h5", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          _c("el-button", {
            staticClass: "small-btn",
            attrs: {
              type: "success",
              plain: "",
              size: "mini",
              icon: "fa fa-refresh"
            },
            on: { click: _vm.onRefresh }
          })
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.taskList,
            border: "",
            "header-cell-style": {
              background: "rgb(48, 65, 86)",
              color: "white"
            },
            height: "480px"
          },
          on: { "row-click": _vm.onClickTask }
        },
        [
          _c("el-table-column", {
            attrs: {
              property: "node",
              label: _vm.$t("Node"),
              width: "120",
              align: "left"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "a-tag",
                        on: {
                          click: function($event) {
                            return _vm.onClickNode(scope.row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.node_name))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              property: "spider_name",
              label: _vm.$t("Spider"),
              width: "120",
              align: "left"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "a-tag",
                        on: {
                          click: function($event) {
                            return _vm.onClickSpider(scope.row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.spider_name))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              property: "param",
              label: _vm.$t("Parameters"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.param))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              property: "result_count",
              label: _vm.$t("Results Count"),
              width: "60",
              align: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.result_count))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("Status"), align: "left", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("status-tag", { attrs: { status: scope.row.status } })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              property: "create_ts",
              label: _vm.$t("Create Time"),
              width: "150",
              align: "left"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "a-tag",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.onClickTask(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm
                                .getTime(scope.row.create_ts)
                                .format("YYYY-MM-DD HH:mm:ss")
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }